import React from 'react';
import './Services.css';
import { useTranslation } from 'react-i18next';
import easyParticipation from '../../../pic/easy-participation.png'
import insightsDashboard from '../../../pic/insights-dashboard.png'
import expertRecommandation from '../../../pic/expert-recommandation.png'
import dailyTracking from '../../../pic/daily-tracking.png'
import personalInsights from '../../../pic/personal-insights.png'
import communitySupport from '../../../pic/community-support.png'
const Services = () => {
    const { t } = useTranslation();
    
    const servicesData = [
        {
            title: t('services.easyParticipation'),
            description: t('services.easyParticipationDesc'),
            icon: easyParticipation
        },
        {
            title: t('services.insightsDashboard'),
            description: t('services.insightsDashboardDesc'),
            icon: insightsDashboard
        },
        {
            title: t('services.expertRecommendations'),
            description: t('services.expertRecommendationsDesc'),
            icon: expertRecommandation
        },
        {
            title: t('services.dailyTracking'),
            description: t('services.dailyTrackingDesc'),
            icon: dailyTracking
        },
        {
            title: t('services.personalizedInsights'),
            description: t('services.personalizedInsightsDesc'),
            icon: personalInsights
        },
        {
            title: t('services.communitySupport'),
            description: t('services.communitySupportDesc'),
            icon: communitySupport
        },
    ];
    return (
        <section className="services-section">
            <h2 className="services-title">{t('services.title')}</h2>
            <p className="services-subtitle">
                {t('services.subtitle')}
            </p>
            <div className="services-grid">
                {servicesData.map((service, index) => (
                    <div key={index} className="service-card">
                        <div className="service-icon">
                            <img src={service.icon} alt={service.title} />
                        </div>
                        <h3 className="service-title">{service.title}</h3>
                        <p className="service-description">{service.description}</p>
                    </div>
                ))}
            </div>
            <button className="learn-more-button">{t('services.learnMore')}</button>
        </section>
    );
};

export default Services;
